import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ContactSection from '../../components/feature/ContactSection';
import HeroSection from './components/HeroSection';
import ServicesPreview from './components/ServicesPreview';
import WhyChooseUs from './components/WhyChooseUs';
import HowItWorks from './components/HowItWorks';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <ServicesPreview />
      <WhyChooseUs />
      <HowItWorks />
      <ContactSection />
      <Footer />
    </div>
  );
}